import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Services = lazy(() => import('../pages/services/page'));
const Company = lazy(() => import('../pages/company/page'));
const Recruit = lazy(() => import('../pages/recruit/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/company',
    element: <Company />,
  },
  {
    path: '/recruit',
    element: <Recruit />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
